import React, { useEffect, useState } from 'react'
import { Icon } from '@iconify/react/dist/iconify.js';
import DataTableLayer from '../../components/DataTableLayer'
import { useAuth } from '../../context/AuthContext';
import PostByAgg from '../../utils/axios';
import DetailTrackForm from './DetailTrack';
import ModalAlert from '../../components/ModalAlert';

const CatalogueForm = ({data,mode,onClose,onSubmit, open, previewImage,setPreviewImage}) => {


    const [formData,setFormData] = useState({
            music_label_code: "",
            music_label_name: "",
            status_code: "",
            upload_url:"",
            image_url:"",
            status_name: "",
            release_type_name: "",
            genre_code: "",
            genre_name: "",
            sub_genre_code: "",
            sub_genre_name: "",
            release_code: "",
            title: "",
            sub_title: "",
            release_date: "",
            i_inline: "",
            c_inline: "",
            created_at: "",
            trackList: [],
            release_channels: []
    })
    const {roleCode} = useAuth()
    const [modalOpen, setModalOpen] = useState(false)
    const [isThumbnail, setIsThumbnail] = useState(true);
    const [detailtrack,setDetailTrack] = useState([])
    const [pagination, setPagination] = useState({
            pageIndex: 0,
            pageSize: 0,
            totalRecords: 0,
            totalPages: 0,
    })
    const [openDetailTrack,setOpenDetailTrack] = useState(false)
    const [selectedRowViewDetail,setSelectedRowViewDetail] = useState({})

    const formatDate = (isoDate) => {
        const date = new Date(isoDate);
        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0'); // Month is 0-indexed
        let year = date.getFullYear();

        if (year === 1) {
            year = 1000; // Ubah tahun menjadi 1000 jika tahun adalah 1
        }
    
        return `${day}-${month}-${year}`;
    }

   
const getImage = (path) => {
  const url = `song/v1/release/get-image?path=${encodeURIComponent(path)}`;  // Endpoint API untuk mengambil gambar

  PostByAgg({
    url: url,
    body: {},  // API tidak membutuhkan body, hanya query parameter
    onResponse: (response) => {
      console.log("Gambar berhasil diambil:", response);
      if (response.data.data) {
        setPreviewImage(response.data.data);  // Set URL gambar dari API response
      } else {
        console.error("Gambar tidak ditemukan");
      }
    },
    onError: (err) => {
      console.error("Gagal mengambil gambar:", err);
    }
  });
};

useEffect(() => {
  if (data && data.image_url) {
    getImage(data.image_url);
  }
}, [data]);


    useEffect(() => {
        console.log("Detail Track : ", data)
        if (data) {
            const releaseList = data.original || data;
            setFormData({
                music_label_code: releaseList.music_label_code || '',
                music_label_name: releaseList.music_label_name || '',
                upload_url: releaseList.upload_url || '',
                image_url: releaseList.image_url || '',
                status_code: releaseList.status_code || '',
                status_name: releaseList.status_name || '',
                release_type_name: releaseList.release_type_name || '',
                genre_code: releaseList.genre_code || '',
                genre_name: releaseList.genre_name || '',
                sub_genre_code: releaseList.sub_genre_code || '',
                sub_genre_name: releaseList.sub_genre_name || '',
                release_code: releaseList.release_code || '',
                title: releaseList.title || '',
                sub_title: releaseList.sub_title || '',
                release_date: releaseList.release_date ? formatDate(releaseList.release_date) : '',
                i_inline: releaseList.i_inline || '',
                c_inline: releaseList.c_inline || '',
                created_at: releaseList.created_at || '',
                trackList: releaseList.songs || [],
                release_channels: releaseList.release_channels || []
            })
        }
    },[data])

    const handleSubmit = (e) => {
        e.preventDefault();
        if (onSubmit) {
          onSubmit(formData);
        }
      };
    
      const handleClose = () => {
        if (onClose) {
          onClose();
        }
      };

      const isReadOnly = mode === 'view';

      const columns =[
          {
            header: 'Title',
            accessorKey: 'title',
          },
          {
            header: 'Sub Title',
            accessorKey: 'sub_title',
          },
          {
            header: 'Pline',
            accessorKey: 'i_inline',
          },
          {
            header: 'Production Year',
            accessorKey: 'production_year',
          },
          {
            header: 'Maker',
            accessorKey: 'maker',
          },
          {
            header: 'ISRC',
            accessorKey: 'isrc',
          },
          {
            header: 'Catalog Number',
            accessorKey: 'catalog_number',
          },
          {
            header: 'Preview Start',
            accessorKey: 'preview_start',
            // cell: ({ row }) => {
            //     const formattedDate = formatDate(row.original.preview_start);
            //     return <span>{formattedDate}</span>;
            // },
          },
          {
            header: 'Lyric',
            accessorKey: 'lyric',
          },
          {
            header: 'Viewers',
            accessorKey: 'count_of_viewers',
          },

           ...(roleCode === 'RL2411062373407' ? [
                {
                    header: 'Pendapatan',
                    accessorKey: 'revenue_amount'
                }
            ] : []),
          {
            header: 'Status',
            cell: ({ row }) => {
              const songChannels = row.original.song_channels;
              const status = songChannels && songChannels[0] ? songChannels[0].status_name : 'N/A';

              let badgeColor;
              let clickHandler = () => {}; 

              switch (status) {
                case "WAITING":
                  badgeColor = "bg-warning";
                  break;
                case "LIVE":
                  badgeColor = "bg-danger";
                  break;
                case "UPLOADED":
                  badgeColor = "bg-info"; // Tambahkan warna khusus untuk "UPLOADED"
                  break;
                default:
                  badgeColor = "bg-success";
                  break;
              }

              
              return (
                <span onClick={clickHandler} className={`badge ${badgeColor}`}>
                  {status}
                </span>
              );
            }
          },
          {
            header:'Status Bayar',
            accessorKey:'status_paid'
          },
          {
            header: 'Action',
            accessorKey: 'action',
            cell:({row})=>{
                return <button className="btn btn-warning btn-sm cursor-pointer" onClick={() => handleDetails(row)}>Details</button>
            }
          },
      ]

      const GetDetailTrackList = () => {
        const url = 'song/v1/track/list'
        const releaseCode = data.original.release_code
        PostByAgg({
            url: url,
            body: {
                "page_size":pagination.totalRecords,
                "page":pagination.pageIndex + 1,
                "release_code":releaseCode,
                "keyword":""
            },
            onResponse: onResponseDetailTrackList,
            onError: onErrorDetailTrackList
        })
      }

      function onResponseDetailTrackList(response) {
        console.log("response detailtrack",response.data)
        if(response.data.data){
            const totalRecords = response.data.data.total_records;
            const totalPages = Math.ceil(totalRecords / pagination.pageSize);
            setPagination((prev) => ({
                ...prev,
                totalRecords: totalRecords,
                totalPages: totalPages,
                pageSize: totalRecords,
                // pageIndex: 0,
            }));
            if(totalRecords>0){
              setDetailTrack(response.data.data.data)
            }
           }else{
            setDetailTrack([])
           } 
      }

      function onErrorDetailTrackList(err) {
        console.log(err)
        const isNotString = val => typeof val !== 'string' && !(val instanceof String);
        let errMessage = err?.response?.data??'';
        if (isNotString(errMessage)) errMessage = JSON.stringify(err.response.data) 
        setModalOpen(
            <ModalAlert
                show = {true}
                type={"failed"}
                /*
                text={err.response.data}
                */
                text={errMessage}
                action={() => {}}
            />
        )
      }

      const handleDetails = (row) => {
        console.log("dortap")
        setOpenDetailTrack(true)
        setSelectedRowViewDetail(row)
      }

      const handleCloseDetailTrack = () => {
        setOpenDetailTrack(false);
        setSelectedRowViewDetail('')
      };

      useEffect(() => {
        GetDetailTrackList()
      }, [pagination.pageIndex, pagination.pageSize])

      const toggleImageSize = () => {
        setIsThumbnail((prev) => !prev); // Toggle nilai boolean
      };


  return (
      <div
          className={`modal fade ${open ? "show" : ""}`}
          tabIndex="-1"
          style={{ display: open ? "block" : "none" }}
          aria-hidden={!open}
      >
          <div className="modal-dialog modal-dialog-centered modal-xl">
              <div className="modal-content">
                  <div className="modal-header justify-content-between">
                      <h5 className="modal-title">{mode === 'create' ? 'Create Release Music' : 'View Release Music'}</h5>
                      <button type="button" className="close" onClick={handleClose}>
                          <Icon icon="mdi:close-circle" width={24} height={24} />
                      </button>
                  </div>
                  <div className="modal-body">
                      <form onSubmit={handleSubmit}>
                      {/* <div className="row gy-3"> */}
                        <div className="container mb-3">
                            {previewImage ? (
                                <div
                                  className="col-sm-12 mt-3 text-center"
                                  style={{
                                    display: 'flex',
                                    flexDirection: 'column', // 👉 baris vertikal
                                    justifyContent: 'center',
                                    alignItems: 'center',
                                    border: '2px dashed #ccc',
                                    padding: '16px'
                                  }}
                                >
                                  <h6 className="form-label mb-3">Preview Cover Image</h6>
                                
                                  <img
                                    src={previewImage}
                                    alt="Cover Preview"
                                    className="img-fluid"
                                    style={{
                                      maxWidth: isThumbnail ? '550px' : '500px',
                                      transition: 'max-width 0.3s ease'
                                    }}
                                  />
                                </div>
                                ) : (
                                // Placeholder for no preview image
                                <div className='d-flex justify-content-center align-items-center'>
                                  <div className="" style={{
                                      border: '2px dashed #ccc', 
                                      padding: '0 120px',
                                      width: '100px', 
                                      // marginLeft: '12px', 
                                      textAlign: 'center',
                                      height: '200px', 
                                      display: 'flex',
                                      justifyContent: 'center',
                                      alignItems: 'center',
                                      flexDirection: 'column'
                                    }}>
                                      <h6 className="form-label">No Image Cover Available</h6>
                                  </div>
                                </div>
                                )}
                        </div>
                     {/* </div> */}
                      <div className="row">
                      {[
                          { label: 'Music Label Name', name: 'music_label_name' },
                          { label: 'Status', name: 'status_name'},
                          { label: 'Judul Release', name: 'title' },
                          { label: 'Sub Title', name: 'sub_title' },
                          { label: 'Release Type', name: 'release_type_name' },
                          { label: 'Genre', name: 'genre_name' },
                          { label: 'Sub Genre', name: 'sub_genre_name' },
                          { label: 'Channels', name: 'release_channels' },
                          { label: 'Release Date', name: 'release_date' },
                          { label: 'Created At', name: 'created_at' },
                      ].map(({ label, name }) => (
                          <div className="col-md-6 mb-3" key={name}>
                            <label className="col-form-label" htmlFor={name}>
                                {label}:
                            </label>
                            { name === 'release_channels' ? (
                               <input
                                type="text"
                                className="form-control"
                                id={name}
                                name={name}
                                value={formData[name].map((channel) => channel.channel_name).join(', ')}
                                readOnly={isReadOnly}
                            />
                            ):(
                            <input
                                type="text"
                                className="form-control"
                                id={name}
                                name={name}
                                value={formData[name] || ''}
                                readOnly={isReadOnly}
                            />
                            )}
                          </div>
                      ))}
                       <div className='col-md-6 mb-3 fs-6 flex-wrap flex-row justify-content-between align-items-center bg-'>
                        <label className=''>Songs Url: </label>
                        <a href={formData.upload_url} target="_blank" rel="noreferrer" className='d-block mt-2' style={{backgroundColor: '#ffff' , padding: '10px', borderRadius: '5px', color: 'blue', textDecoration: 'underline'}}>{formData.upload_url}</a>
                      </div>
                      <div className="col-md-12 mb-3">
                      <DataTableLayer
                            data={detailtrack}
                            pagination={pagination}
                            columns={columns} 
                            title={"Track List"}  
                            onClick={() => {}} 
                            showButton={roleCode === 'RL2411062373407' ? true : false}
                        />
                      </div>
                      {
                        openDetailTrack && (
                            <div className="col-md-12 mb-3">
                                <DetailTrackForm
                                    data={selectedRowViewDetail}
                                    open={openDetailTrack}
                                    mode="detail"
                                    onClose={handleCloseDetailTrack}
                                    onSubmit={()=>{}}
                                />
                            </div>
                        )
                      }
                          {/* <div className="col-md-6 mb-3">
                              <label className="col-form-label" htmlFor="is_partner">
                              Is Partner:
                              </label>
                              {isReadOnly ? (
                              <div className="form-control-plaintext">
                                  <input 
                                      type='text'
                                      className='form-control'
                                      readOnly
                                      value={formData.is_partner ? 'Yes' : 'No'}
                                      />
                              </div>
                              ) : (
                              <select
                                  className="form-control"
                                  id="is_partner"
                                  name="is_partner"
                                  value={formData.is_partner}
                                  onChange={handlePartnerChange}
                              >
                                  <option value={false}>No</option>
                                  <option value={true}>Yes</option>
                              </select>
                              )}
                         </div> */}
                      </div>
                      {

                      }
                      <div className="d-flex justify-content-end gap-2 mt-3">
                          {!isReadOnly && (
                          <button type="submit" className="btn btn-primary">
                              {mode === 'create' ? 'Create' : 'Submit'}
                          </button>
                          )}
                          <button type="button" className="btn btn-secondary" onClick={handleClose}>
                          Close
                          </button>
                      </div>
                      {modalOpen}
                      </form>
                  </div>
              </div>
          </div>
      </div>
    );
}

export default CatalogueForm
